/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/
import 'bootstrap/dist/css/bootstrap.min.css';
import React, {useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import '../css/App.css';
import Sidenav from '../Components/Sidenav';
const Protected = (props) => {
    const [showNav,setshowNav] = useState(false);
    const [media ,setmedia]=useState(true)
    let navigate = useNavigate();
    let Protect = props.Protect;

    useEffect (()=>{
        // console.log(window.innerWidth)
        if(window.innerWidth < 600){
          setshowNav(true)
        }
       if(!localStorage.getItem('token')) {
        navigate("/login");
       }else 
       if(localStorage.getItem('role') === 'BACKOFFICE'){
        navigate("/support")
       }
    },[])
    return (
        <div className="con">
            <Sidenav show={showNav} icon={()=>setshowNav(!showNav) }/>
            <Protect icon={()=>setshowNav(!showNav) } />
        </div>
    )
}

export default Protected
